import { Box, Paper } from '@mui/material';
import React from 'react';
import { LayoutRows3 } from '../LayoutRows3';
/**
 * @param {AppPageProps} props - Props to configure header, footer, content area, padding, and scroll behavior.
 * @returns {React.ReactElement} The rendered application page layout.
 * @deprecated Replaced by `GlobalApp`, to control scrolling behavior use `FullHeightPage`, do not use together with `GlobalApp` in new code.
 */
export const AppPage = (props) => {
    return (React.createElement(LayoutRows3, { row1: props.header, row2: React.createElement(Box, { sx: {
                boxSizing: 'border-box',
                height: props.contentScrollable ? undefined : '100%',
                p: {
                    xs: 0,
                    md: 2,
                },
            } },
            React.createElement(Paper, { sx: {
                    boxSizing: 'border-box',
                    width: props.contentWidth ? getContentWidth(props.contentWidth) : undefined,
                    height: props.contentScrollable ? undefined : '100%',
                    margin: props.contentWidth ? 'auto' : undefined,
                    padding: (theme) => (props.contentPadding ? theme.spacing(props.contentPadding) : 0),
                    borderRadius: {
                        xs: 0,
                        md: 'theme.shape.borderRadius',
                    },
                    boxShadow: {
                        xs: 0,
                        md: 4,
                    },
                }, elevation: 4 }, props.children)), row3: props.footer, fullHeightRow: 'row2', row1Scrollable: true, row2Scrollable: props.contentScrollable }));
};
/**
 * Converts a numeric or string-based content width into a CSS `min()` expression constrained to viewport width.
 * @param {number | string} contentWidth - The desired content width, either as a number (pixels) or CSS string.
 * @returns {string} A CSS `min()` expression limiting the width to 100vw.
 */
function getContentWidth(contentWidth) {
    return typeof contentWidth === 'string' ? `min(100vw, ${contentWidth})` : `min(100vw, ${contentWidth}px)`;
}
